const CURRENCY_FORMAT = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'USD',
});

const COUNT_FORMAT = new Intl.NumberFormat();

export const formatAffiliateCurrency = (value: number): string =>
  CURRENCY_FORMAT.format(Number.isFinite(value) ? value : 0);

export const formatAffiliateCount = (value: number): string =>
  COUNT_FORMAT.format(Number.isFinite(value) ? value : 0);
